<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.sr_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
        <div class="weui-form-preview__item" slot="sr_ascode">
            <label class="weui-form-preview__label">{{
              customLabel.sr_ascode || "售后编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sr_ascode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sr_custname">
            <label class="weui-form-preview__label">{{
              customLabel.sr_custname || "客户名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sr_custname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item weui-cell"
            slot="sr_contact"
            v-if="form.main.sr_contact"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sr_contact || "联系人"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.sr_contact }}
            </span>
          </div>
          <div
            class="weui-form-preview__item weui-cell"
            slot="sr_tel"
            v-if="form.main.sr_tel"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sr_tel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.sr_tel }}
            </span>
          </div>
          <div
            class="weui-form-preview__item weui-cell"
            slot="sr_urgency"
            v-if="form.main.sr_urgency"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sr_urgency || "紧急程度"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.sr_urgency }}
            </span>
          </div>
          <div
            class="weui-form-preview__item weui-cell"
            slot="sr_shelflife"
            v-if="form.main.sr_shelflife"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sr_shelflife || "保质期内"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.sr_shelflife }}
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.srd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="srd_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.srd_prodcode || "产品编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.srd_prodcode
              }}</span>
            </div>
             <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "产品名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_detail
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_orispeccode"
              v-if="item.pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.pr_spec"
              slot="pr_spec"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_spec
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_unit"
              v-if="item.pr_unit"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_unit || "单位"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_unit
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="srd_qty"
              v-if="item.srd_qty"
            >
              <label class="weui-form-preview__label">{{
                customLabel.srd_qty || "数量"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.srd_qty
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="srd_currency">
              <label class="weui-form-preview__label">{{
                customLabel.srd_currency || "币种"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_currency }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="srd_cost">
              <label class="weui-form-preview__label">{{
                customLabel.srd_cost || "维修费用"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_cost }}</span>
            </div>
            <div class="weui-form-preview__item" slot="srd_status" v-if="item.srd_status">
              <label class="weui-form-preview__label">{{
                customLabel.srd_status || "维修方法"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_status }}</span>
            </div>
            <div class="weui-form-preview__item" slot="srd_describe" v-if="item.srd_describe">
              <label class="weui-form-preview__label">{{
                customLabel.srd_describe || "故障描述"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_describe }}</span>
            </div>
             <div class="weui-form-preview__item" slot="srd_batchcode" v-if="item.srd_batchcode">
              <label class="weui-form-preview__label">{{
                customLabel.srd_batchcode || "批次号"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_batchcode }}</span>
            </div>
             <div class="weui-form-preview__item" slot="srd_serial"  v-if="item.srd_serial">
              <label class="weui-form-preview__label">{{
                customLabel.srd_serial || "序列号"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.srd_serial }}</span>
            </div>
            <div class="weui-form-preview__item" slot="srd_produced_date" v-if="item.srd_produced_date">
              <label class="weui-form-preview__label">{{
                customLabel.srd_produced_date || "生产日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.srd_produced_date,'yyyy-MM-dd')
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.srd_salecode"
              slot="srd_salecode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.srd_salecode || "关联订单"
              }}</label>
              <span class="weui-form-preview__value">{{ item.srd_salecode }}</span>
            </div>
            <div
              class="weui-form-preview__item weui-cell"
              slot="srd_purchase_date"
              v-if="item.srd_purchase_date"
            >
              <label class="weui-form-preview__label">{{
                customLabel.srd_purchase_date || "购买日期"
              }}</label>
              <span class="weui-form-preview__value">{{  dateFormat(item.srd_purchase_date,'yyyy-MM-dd') }} </span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/after_sale_repair_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
       <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_after_sales"
        >转售后领料</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout
  },
  data() {
    return {
      baseUrl: "/api/sale/afterSaleRepair",
      codeField: "sr_code",
      statusField: "sr_status_code",
      caller: "AfterSaleRepair",
      xtype: "sale-afterSaleRepair-formpanel",
    };
  },
  methods:{
    turnin_after_sales() {
      var me = this;
       me.$router.push({
            name: "AfterSalePickEdit",
            params: {
              form:me.form
            }
          });
    },
  }
};
</script>